"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var i18next_1 = __importDefault(require("i18next"));
var Section_1 = __importDefault(require("../Section"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c;
    return core_1.createStyles({
        footer: (_a = {
                display: 'flex',
                justifyContent: 'space-between'
            },
            _a[theme.breakpoints.down('sm')] = {
                display: 'grid',
            },
            _a),
        appHeaderGroup: {
            gridRow: 1,
            display: 'flex',
            alignItems: 'baseline',
            flexWrap: 'wrap',
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        appTitle: {
            marginRight: theme.spacing(2),
            fontWeight: 700,
        },
        appCatchPhrase: {
            fontWeight: 400,
        },
        navLinkGroup: (_b = {
                gridRow: 1,
                gridColumn: 2,
                display: 'flex',
                flexDirection: 'column',
                marginBottom: theme.spacing(2)
            },
            _b[theme.breakpoints.up('sm')] = {
                flexDirection: 'row',
            },
            _b[theme.breakpoints.up('md')] = {
                gridColumn: 1,
                marginBottom: theme.spacing(0),
                alignItems: 'center',
            },
            _b[theme.breakpoints.down('sm')] = {
                display: 'grid',
                gridRow: 2,
                gridColumn: 1,
            },
            _b),
        navLink: (_c = {
                fontSize: '0.75rem',
                marginTop: theme.spacing(2)
            },
            _c[theme.breakpoints.up('sm')] = {
                marginLeft: theme.spacing(3),
            },
            _c[theme.breakpoints.down('sm')] = {
                marginLeft: 0,
            },
            _c[theme.breakpoints.up('md')] = {
                marginTop: theme.spacing(0),
            },
            _c),
        footerLink: {
            color: theme.palette.primary.dark,
        },
        buildByLink: {
            gridRow: 3,
        },
    });
});
var BaseLayoutFooter = function () {
    var classes = useStyles();
    var footers = [
        { text: 'FAQ', link: i18next_1.default.t('general.links.faq') },
        {
            text: 'Help us improve',
            link: i18next_1.default.t('general.links.contact'),
        },
        { text: 'Privacy', link: i18next_1.default.t('general.links.privacy') },
        { text: 'Terms of Use', link: i18next_1.default.t('general.links.terms') },
    ];
    return (react_1.default.createElement(Section_1.default, { backgroundType: "dark", verticalMultiplier: 0.5 },
        react_1.default.createElement("footer", { className: classes.footer },
            react_1.default.createElement("div", { className: classes.appHeaderGroup },
                react_1.default.createElement(core_1.Typography, { className: classes.appTitle, variant: "body1", color: "textPrimary" },
                    react_1.default.createElement("strong", null, i18next_1.default.t('general.appTitle'))),
                react_1.default.createElement(core_1.Typography, { variant: "body2", color: "textPrimary", noWrap: true, className: classes.appCatchPhrase }, i18next_1.default.t('general.appCatchphrase.noStyle'))),
            react_1.default.createElement("div", { className: classes.navLinkGroup }, footers.map(function (footer) { return (react_1.default.createElement(core_1.Typography, { className: classes.navLink, key: footer.text, variant: "caption" },
                react_1.default.createElement(core_1.Link, { className: classes.footerLink, target: "_blank", href: footer.link }, footer.text))); })))));
};
exports.default = BaseLayoutFooter;
